//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import constant from '~/const';
import IdentificationTable from '~/views/UserId/IdentificationTable.vue';
import WarningTable from '~/views/UserId/WarningTable.vue';
import BlockTable from '~/views/UserId/BlockTable.vue';
import BasicInfo from '~/views/UserId/BasicInfo.vue';
import UserVerificationRequests from '~/views/UserId/UserVerificationRequests/UserVerificationRequests.vue';
import AddDocuments from '~/views/UserId/UserVerificationRequests/modals/AddDocuments/AddDocuments.vue';
import DeleteUser from '~/views/UserId/DeleteUser.vue';
import UserRequisites from '~/views/UserId/UserRequisites/UserRequisites.vue';
import UserLeads from './UserLeads.vue';

export default {
  components: {
    IdentificationTable,
    BasicInfo,
    UserRequisites,
    WarningTable,
    BlockTable,
    UserVerificationRequests,
    AddDocuments,
    DeleteUser,
    UserLeads,
  },

  computed: {
    ...mapState('user', ['user']),

    referralPayload() {
      const { id, roles } = this.user;
      if (roles.includes(this.constant.users.USER_ROLE.TRADER)) return { traderId: id };
      if (roles.includes(this.constant.users.USER_ROLE.TRADER_LEAD)) return { leadId: id };
      return null;
    },

    hasToShowLeads() {
      const { roles } = this.user;
      if (!roles || roles.length === 0) return false;
      return roles.includes(this.constant.users.USER_ROLE.TRADER) || roles.includes(this.constant.users.USER_ROLE.TRADER_LEAD);
    },
  },

  data() {
    return {
      constant,
    };
  },

  async mounted() {
    this.setGeneralLoader(true);

    if (this.$utils.getAppType() !== 'p2pay') {
      await this.loadUserDocuments();
      await this.loadUserVerificationRequests();
      await this.loadP2pArbitratorsList();
    } else {
      await this.loadFees();
      await this.loadUserProfile(this.user?.id);
      await this.loadPersonalFees({ userId: this.user?.id });
      await this.loadDeals({ userId: this.user?.id });
      await this.loadUserDevices({ userId: this.user?.id });
      await this.loadTradersCurrencies({ limit: 1000 });
      await this.loadUserRequisites({ userId: this.user?.id });
      await this.loadTradersOffers({ userId: this.user?.id });
      await this.loadUserGoups();
      await this.loadPaymentMethods();
      await this.loadTraderLeadReferralsAction(this.referralPayload);
    }
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader', 'setSuccessNotification']),
    ...mapActions('userId', ['loadUserDocuments']),
    ...mapActions('userRequisites', {
      loadUserRequisites: 'loadData',
    }),
    ...mapActions('userVerificationRequests', {
      loadUserVerificationRequests: 'loadData',
    }),
    ...mapActions('tradersDeals', {
      loadDeals: 'loadData',
    }),
    ...mapActions('p2pArbitratorsList', {
      loadP2pArbitratorsList: 'loadData',
    }),
    ...mapActions('tradersFees', {
      loadPersonalFees: 'loadPersonalFeeDataById',
    }),
    ...mapActions('tradersFees', {
      loadFees: 'loadData',
    }),
    ...mapActions('tradersCurrencies', {
      loadTradersCurrencies: 'loadData',
    }),
    ...mapActions('tradersOffers', {
      loadTradersOffers: 'loadData',
    }),
    ...mapActions('tradersPaymentMethods', {
      loadPaymentMethods: 'loadData',
    }),
    ...mapActions('userDevices', {
      loadUserDevices: 'loadData',
    }),
    ...mapActions('usersGroups', {
      loadUserGoups: 'getGroups',
    }),
    ...mapActions('userProfile', {
      loadUserProfile: 'loadData',
    }),
    ...mapActions('referrals', {
      loadTraderLeadReferralsAction: 'loadTraderLeadReferrals',
    }),
  },
};
